import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { Country, CountryCollection } from '@/models/Country';
import type { QueryParams } from '@kp/js-model';
import type { Ref } from 'vue';

/**
 * Creates a reactive connection between a BaugemeindeCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */

export function useCountryCollection(options: UseCollectionOptions = {}, queryParams: QueryParams = {}) {
    const country = new CountryCollection();
    country.setQueryParams(queryParams);
    const initialFilters: ApiFilter[] = [];

    const refs = useCollection(country, {
        ...{
            tableSort: [],
            collectionsFilter: initialFilters,
            pageSize: 5
        },
        ...options
    });
    return refs;
}
